/**
 * @example
 * // 0.000123
 * formatNumber(0.000123,{displayDecimals:getFirstNonZeroDecimalPlace}) => 0.0001
 */
export function getFirstNonZeroDecimalPlace(
  decimalNumber: string,
  fallback = 2,
) {
  const unsigned = decimalNumber.replace(/^[-+]/, '');
  const [integer, decimalsDigits] = unsigned.split('.');
  if (!decimalsDigits) return fallback;
  if (integer !== '0') return fallback;
  const diffIndex = decimalsDigits.split('').findIndex((d) => d !== '0');

  return Math.max(fallback, diffIndex + 1);
}
